import { clsx } from "clsx";

/**
 * cn — the standard shadcn/ui className helper.
 *
 * Merges conditional class names via clsx. (The upstream shadcn version also
 * runs the result through tailwind-merge to dedupe conflicting Tailwind
 * classes; we intentionally skip that dependency here since our own class
 * strings don't conflict.)
 */
export function cn(...inputs) {
  return clsx(inputs);
}
